import { permissionsRol as publicationRol } from 'app/policies/roles/publicationsRol.access';
import { PATH_PUBLICATION, PATH_PUBLICATIONS, PATH_PUBLICATION_CREATE } from 'app/router/routesConfigPublications';

export function publications(path, user) {
  if (PATH_PUBLICATION === path) {
    return publicationRol(user).readDetail;
  }

  if (PATH_PUBLICATIONS === path) {
    return publicationRol(user).readList;
  }

  if (PATH_PUBLICATION_CREATE === path) {
    return publicationRol(user).create;
  }

  return true;
}
